import { createContext, useContext, useEffect, useState } from 'react';

const IntroContext = createContext(false);

export function IntroProvider({ children, duration = 2200 }) {
  const [isIntro, setIsIntro] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setIsIntro(false), duration);
    return () => clearTimeout(t);
  }, [duration]);

  return <IntroContext.Provider value={isIntro}>{children}</IntroContext.Provider>;
}

export default function useIntro() {
  return useContext(IntroContext);
}
